<template>
  <section class="card mb-4 card-info card-outline" role="region" id="profile-frontend">
    <div class="card-header">
      <h3 class="card-title">
        Server
        <small
          class="badge badge-pill badge-success"
          v-if="onAir"
          key="lang_frontend_running"
        >Running</small>
        <small
          class="badge badge-pill badge-danger"
          v-else
          key="lang_frontend_not_running"
        >Not Running</small>
        <br />
        <!-- <small>{{ 'Server' }}</small> -->
      </h3>
    </div>

    <template v-if="userCanManageBroadcasting">
      <!-- <table class="table table-striped table-responsive mb-0">
                <colgroup>
                    <col width="30%">
                    <col width="70%">
                </colgroup>
                <tbody>
                <tr>
                    <td  >Source User: </td>
                    <td>
      <span>{{ station.dj_username }}</span>-->
      <!-- <copy-to-clipboard-button target="#frontend_source_pw" hide-text></copy-to-clipboard-button> -->
      <!-- </td>
                </tr>
                <tr>
                    <td >Source Password: </td>
                    <td>
      <span>{{ station.dj_password }}</span>-->
      <!-- <copy-to-clipboard-button target="#frontend_relay_pw" hide-text></copy-to-clipboard-button> -->
      <!-- </td>
                </tr>
                </tbody>
      </table>-->

      <div class="card-footer">
        <div class="card-actions">
          <button
            :disabled="status.restarting || status.processing"
            @click="serverAction(restartUri, 'restarting')"
            class="btn btn-outline-info btn-sm mr-2"
          >
            <i class="fas fa-redo-alt"></i>
            {{status.restarting? 'restarting...':'Restart'}}
          </button>
          <button
            :disabled="status.processing || status.restarting"
            @click="serverAction(startUri, 'processing')"
            class="btn btn-outline-success btn-sm"
            v-show="!onAir"
          >
            <i class="fas fa-play-circle"></i>
            {{status.processing? 'starting...':'Start'}}
          </button>
          <button
            :disabled="status.processing || status.restarting"
            @click="serverAction(stopUri, 'processing')"
            class="btn btn-outline-danger btn-sm"
            v-show="onAir"
          >
            <i class="fas fa-stop-circle"></i>
            {{status.processing? 'stopping...':'Stop'}}
          </button>
        </div>
      </div>
    </template>
  </section>
</template>


<script>
// import CopyToClipboardButton from '../components/CopyToClipboardButton';
import ServerActionMixin from "@/plugins/mixins/serverAction";
export default {
  // components: { CopyToClipboardButton },
mixins:[ServerActionMixin],


};
</script>


        
